import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { HomeOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useBreadcrumbs } from "../../../context/breadcrumbs";
import { Button } from "antd";

function ToolBar() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return [
    <Button
      key="add"
      icon={<PlusCircleOutlined />}
      type="primary"
      onClick={(e) => {
        e.preventDefault();
        navigate("create");
      }}
    >
      Create
    </Button>,
  ];
}

export default function SurveyContent() {
  const { t, i18n } = useTranslation();
  const { setBreadcrumbs } = useBreadcrumbs();

  // Static trail, no derivation: the shell resets the breadcrumbs on every
  // screen and only the screen itself fills them in. Building them from the
  // route is a developer's job — see DEVELOPER_TASKS.md.
  useEffect(() => {
    setBreadcrumbs([
      { title: <HomeOutlined />, href: "/" },
      { title: t("routes.survey") },
    ]);
  }, [i18n.language, t]);

  return (
    <div title="Survey">
      <ToolBar />
    </div>
  );
}
